import { apiClient } from '@/shared/lib/axios';

export type ClinicInformationListParams = {
  clinic_number?: string;
  clinic_name?: string;
  available_date?: string;
  site_types?: string[];
  sort?: [string, 'asc' | 'desc'];
  page?: number;
  per_page?: number;
};

export type ClinicInformationListItem = {
  id: number;
  clinic_number: string;
  sub_number: number;
  clinic_information_id: string;
  name: string;
  available_from: string | null;
  available_to: string | null;
  site_type?: string | null;
};

export type ClinicInformationListMeta = {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
};

export type ClinicInformationListResponse = {
  success: boolean;
  data: {
    data: ClinicInformationListItem[];
  };
  meta: ClinicInformationListMeta;
  message?: string;
};

export const getClinicInformations = async (
  site: string,
  params: ClinicInformationListParams
): Promise<ClinicInformationListResponse> => {
  const response = await apiClient.get<ClinicInformationListResponse>(
    `/admin/${site}/clinic-informations`,
    { params }
  );

  return response.data;
};

export const downloadClinicInformationsCsv = async (
  site: string,
  params: ClinicInformationListParams
): Promise<void> => {
  const response = await apiClient.get(`/admin/${site}/clinic-informations/csv`, {
    params,
    responseType: 'blob',
  });

  const blob = new Blob([response.data], { type: 'text/csv;charset=Shift_JIS;' });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = `clinic_information${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

